import { render, staticRenderFns } from "./BaseArrowForm.vue?vue&type=template&id=b55fb2ac&"
import script from "./BaseArrowForm.vue?vue&type=script&lang=js&"
export * from "./BaseArrowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports